import 'vant/lib/cascader/index.less'

// 依赖
import '../preview-text/style'
